var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TimeslotAuthLayout',[(_vm.screen === 'register')?_c('TimeslotSignUpForm'):_vm._e(),(_vm.screen === 'otp')?_c('TimeSlotOtpForm',{attrs:{"message":'Verify email'}}):_vm._e(),(_vm.screen === 'success')?_c('TimeSlotSuccess',{attrs:{"message":'You have successfully created your account'}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }